module.exports = __webpack_public_path__ + "assets/img/mecha-active-btn-ecced0f4.png";